import React, { useState, useEffect } from "react";
import { Badge, IconButton } from "@mui/material";
import { Chat as ChatIcon } from "../icons";
import { Link } from "react-router-dom";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { auth, db } from "../firebase";

// Ícono de chat con badge de no leídos para la bottom nav (antes vivía en el
// FAB flotante de FloatingMenu.js, ahora inline entre "Buscar" y el botón QR).
//
// Los chats viven en Firestore (conversations/{id}, ver chatbox.js y
// Directchatbox.js), que ya llevan unreadCount.{uid} por participante. Antes
// este badge leía el nodo "chats" de la Realtime Database, que ya no escribe
// nadie: bajaba todos los chats al cliente (warning de ".indexOn") y no
// reflejaba los mensajes reales.
// Cantidad de mensajes sin leer del usuario actual, en tiempo real. Se
// exporta para la sidebar de escritorio (components/DesktopSidebar.js).
export const useUnreadMessageCount = () => {
  const [unreadMessageCount, setUnreadMessageCount] = useState(0);

  useEffect(() => {
    let unsubscribeConversations = null;

    const unsubscribeAuth = auth.onAuthStateChanged((user) => {
      if (unsubscribeConversations) {
        unsubscribeConversations();
        unsubscribeConversations = null;
      }
      if (!user) {
        setUnreadMessageCount(0);
        return;
      }

      const conversationsQuery = query(
        collection(db, "conversations"),
        where("participants", "array-contains", user.uid)
      );
      unsubscribeConversations = onSnapshot(
        conversationsQuery,
        (snapshot) => {
          let unreadCount = 0;
          snapshot.forEach((conversationDoc) => {
            unreadCount += Number(conversationDoc.data().unreadCount?.[user.uid]) || 0;
          });
          setUnreadMessageCount(unreadCount);
        },
        (error) => {
          console.error("Error loading unread messages:", error);
        }
      );
    });

    return () => {
      unsubscribeAuth();
      if (unsubscribeConversations) unsubscribeConversations();
    };
  }, []);

  return unreadMessageCount;
};

const ChatNavButton = ({ sx }) => {
  const unreadMessageCount = useUnreadMessageCount();

  return (
    <IconButton id="tour-chats-btn" component={Link} to="/chats" sx={sx}>
      <Badge badgeContent={unreadMessageCount} color="error" invisible={unreadMessageCount === 0}>
        <ChatIcon />
      </Badge>
    </IconButton>
  );
};

export default ChatNavButton;
